<app-header [(sidebarVisible)]="sidebarVisible"></app-header>
<p-sidebar
  *ngIf="isMobile"
  [(visible)]="sidebarVisible"
  styleClass="wid-252-im sidebar-mobile"
  (visibleChange)="onToggleSidebar($event)"
>
  <ng-template pTemplate="header">
    <div class="header-logo d-flex justify-content-center align-items-center">
      <a id="logo" routerLink="/">
        <img
          src="/assets/icons/SCGC_4C_logo_3889x1963px.png"
          height="63"
          class="d-inline-block align-top"
          alt=""
          loading="lazy"
        />
      </a>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <app-sidebar [(menuItems)]="menuItems" id="sidebar"></app-sidebar>
  </ng-template>
  <!-- <ng-template pTemplate="footer">Footer Content</ng-template> -->
</p-sidebar>
<!-- <app-sidebar *ngIf="!isMobile"></app-sidebar> -->
<div class="d-flex">
  <app-sidebar
    id="sidebar"
    *ngIf="!isMobile"
    [ngClass]="{ 'hide-sidebar': !sidebarVisible }"
    [(menuItems)]="menuItems"
  ></app-sidebar>
  <div class="content-layout w-100">
    <div *ngIf="breadcrumbService.breadcrumbItems.length; then hasItem; else noItem"></div>
    <main
      class="p-x-25 p-t-25"
      [ngStyle]="{
        'max-width': sidebarVisible && !isMobile ? 'calc(100vw - 250px)' : '100vw'
      }"
    >
      <div class="page m-b-25">
        <router-outlet></router-outlet>
      </div>
      <div class="footer text-secondary">
        <span class="m-l-10">
          {{ APP_COPYRIGHT }} 
        </span>
          &nbsp;&nbsp;
        <a (click)="onClickPrivacyNotice()" style="cursor: pointer;">
          <h5> Privacy Notice</h5>
        </a>
        <label>&nbsp; | &nbsp;</label>
        <a (click)="onClickCookieNotice()" style="cursor: pointer;">
            <h5>Cookie Notice</h5>
        </a>
      </div>
    </main>
  </div>
</div>
<!-- <router-outlet></router-outlet> -->
<!-- <ngx-spinner type="ball-clip-rotate" color="#ffffff">
  <p style="color: white">{{ AppConfig.LOADING_TEXT }}</p>
</ngx-spinner> -->
<ng-template #hasItem
  ><p-breadcrumb
    class="max-w-full"
    styleClass="header-breadcrumb"
    [model]="breadcrumbService.breadcrumbItems"
    [home]="home"
  ></p-breadcrumb
></ng-template>
<ng-template #noItem
  ><p-breadcrumb
    class="max-w-full"
    styleClass="header-breadcrumb"
    [home]="home"
  ></p-breadcrumb
></ng-template>
